import axios from 'axios'

class AuthService {
  signIn = (signInData) =>
    axios({
      url: 'auth/admin/signin',
      method: 'POST',
      data: signInData,
    })

  signOut = () => {
    return axios.post('/logs')
  }

  refreshAccessToken = (refreshToken) =>
    axios({
      url: 'auth/refresh-token',
      method: 'POST',
      data: {
        refreshToken,
        extendResponse: true,
      },
      _skipAuthInterceptor: true,
    })
  }

export default new AuthService()
